<template>
  <div class="row">
    <div class="col-8">
      <BreadCrumb :page="page" />
    </div>
    <div class="col-4 text-right">
      <ActionButton
        variant="outline-success mr-2"
        i="fas fa-arrow-circle-left"
        text="Regresar"
        @click="() => $router.back()"
      />
      <ActionButton
        v-if="canAdd"
        class="btn-success success"
        i="fas fa-file-alt"
        type="button"
        @click="determination(goDetermination)"
      >
        Añadir
      </ActionButton>
    </div>
    <div class="col-12">
      <div class="dropdown-divider mt-0 pb-2 w-100 mb-4" />
      <div class="tab-content">
        <div>
          <SectionTitle :content="title" :has-line="true" />
          <component
            :is="dynamicComponent"
            :items="items"
            @deleteAnalysisExistingInformation="getItems"
            @on-open-details="onOpenDetailsHandler"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from '@/components/common/page/TitleBreadcrumb';
import { SectionTitle } from '@/components/pei/shared';
import {
  AddAnalysisEligibilityBox,
  AnalysisExistingInformation,
} from './components';
import StudentStatuses from '@/utils/constants/reg/studentStatuses.js';
import mixAlert from '@/mixin/alert.mixin';
import { ActionButton } from '@/components/common';

export default {
  name: 'TriannualDeterminationProcessMain',
  mixins: [mixAlert],
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Proceso Determinación Trianual',
        routes: ['Inicio', 'Estudiante', 'Proceso de Evaluación Trianual'],
      },
      goDetermination: {
        path: '/student/AddProcessDeterminationTriannual',
        query: {
          isAdd: true
        }
      },
      dynamicComponent: 'AddAnalysisEligibilityBox',
      title: 'Determinaciones de Elegibilidad Trianual del Estudiante',
      items: [],
      canAdd: false,
    };
  },
  computed: {
    studentSieId() {
      return this.$store.getters.SelectedStudent.studentId;
    },
    selectedStudent() {
      return this.$store.getters.SelectedStudent;
    },
    isStudenElegible() {
      if (this.selectedStudent != null) {
        let status = this.selectedStudent.status;
        switch (status) {
          case StudentStatuses.Servido:
            return true;
          case StudentStatuses.Elegible:
            return true;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    studentStatus() {
      return this.$store.getters.SelectedStudent.status;
    },
  },
  components: {
    BreadCrumb,
    SectionTitle,
    AddAnalysisEligibilityBox,
    AnalysisExistingInformation,
    ActionButton,
  },
  methods: {
    async getItems() {
      this.$ApiGet(
        `/api/triannualstudentevaluation/${this.studentSieId}/selectedevaluations/0`
      ).then((response) => {
        this.items = response.data.map((x) => {
          x.isOpenA = false;
          x.isOpenB = false;
          return x;
        });
        if (this.items.length > 0) {
          this.dynamicComponent = 'AnalysisExistingInformation';
          this.title = 'Análisis de Información Existente';
          //if there is any pending validation, block the add button.
          this.canAdd = !this.items.filter((x) => !x.hasTriannual).length > 0;
        } else {
          this.canAdd = true;
        }
      });
    },
    determination(goDetermination) {
      if (!this.isStudenElegible) {
        this.ShowToast(
          'Error al crear proceso de análisis.',
          `No podrá crear un nuevo proceso de análisis ya que el estudiante se encuentra en estatus ${this.studentStatus}.`,
          'error'
        );
        return;
      }

      this.$router.push(goDetermination);
    },
    onOpenDetailsHandler(item, side) {
      this.items = this.items.map((x) => {
        if (
          x.evaluationDateTransactionId === item.evaluationDateTransactionId
        ) {
          if (side === 'A') {
            x.isOpenA = !x.isOpenA;
            x.isOpenB = false;
          }
          if (side === 'B') {
            x.isOpenB = !x.isOpenB;
            x.isOpenA = false;
          }
        }
        return x;
      });
    },
  },
  async mounted() {
    this.getItems();
  },
};
</script>
